"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEspoolModel = exports.espoolModelUseableDef = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const ArticleBase_1 = require("../ArticleBase");
exports.espoolModelUseableDef = {
    parent: ArticleBase_1.articleBaseUseableDef,
    validation: {
        ArticleType: (v) => v === echain_product_models_1.ArticleType.espool,
    },
};
exports.isEspoolModel = echain_shared_modelling_1.UseableUtil.createGuard(exports.espoolModelUseableDef);
//# sourceMappingURL=EspoolModel.js.map